export default {
  //导入客户模板地址
  customerImportTemplateUrl: 'static/files/客户导入模板.xlsx',
  supplierImportTemplateUrl: 'static/files/供应商导入模板.xlsx'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/template/index.js